export const userRoles = [
  {
    code: "user",
    label: "User"
  },
  {
    code: "manager",
    label: "Manager"
  },
  {
    code: "admin",
    label: "Admin"
  },
];

export const offices = [
  {
    code: "brussels",
    label: "Brussels"
  },
  {
    code: "antwerp",
    label: "Antwerp"
  },
  {
    code: "paris",
    label: "Paris"
  },
];

export const departmentRegions = ["brussels"];

export const jobRegions = [
  "antwerp",
  "brussels",
  "paris",
  "flemish_brabant",
  "walloon_brabant",
  "limburg",
  "east_flanders",
  "west_flanders",
  "hainaut",
  "liege",
  "luxembourg",
  "namur",
  "ille-et-vilaine",
  "loire-atlantique",
  "hauts-de-france"
];

export const frenchRegions = ["paris", "ille-et-vilaine", "loire-atlantique", "hauts-de-france"];
export const belgianRegions = jobRegions.filter(region => !frenchRegions.includes(region));

export const flandersRegions = ["antwerp", "flemish_brabant", "limburg", "east_flanders", "west_flanders"];

export const walloniaRegions = ["walloon_brabant", "hainaut", "liege", "luxembourg", "namur"];

export const jobStatuses = ["employee", "freelance", "part-time", "independant", "internship", "student-job"];

export const seniorityLevels = [
  { code: "junior", value: "Junior" },
  { code: "medior", value: "Medior" },
  { code: "senior", value: "Senior" },
  { code: "counsel", value: "Counsel" },
  { code: "partner", value: "Partner" }
];


export const billableHours = [
  { code: "1200-1400", value: "1200-1400" },
  { code: "1400-1600", value: "1400-1600" },
  { code: "1600-1800", value: "1600-1800" },
  { code: "1800-2000", value: "1800-2000" },
  { code: "not_applicable", value: "Not Applicable" }
];

export const barStatusOptions = [
  { code: "bar_trainee", value: "Bar Trainee (BE)" },
  { code: "bar_passed", value: "Bar Passed (BE)" },
  { code: "not_applicable", value: "Not Applicable" }
];

export const offerLanguages = [
  { code: "fr", value: "French" },
  { code: "nl", value: "Dutch"},
  { code: "en", value: "English"},
];

export const languages = [
  { code: "fr", value: "French" },
  { code: "nl", value: "Dutch"},
  { code: "en", value: "English"},
];

export const adminMenuEntries = ["Dashboard", "Profile", "Departments", "Employees", "Jobs", "Reports", "Resumes", "Presentations", "Logout"];
export const userMenuEntries = ["Dashboard", "Resumes", "Presentations", "Profile", "Logout"];

export const statusChipColor = {
  draft: "warning",
  scheduled: "info",
  online: "success",
  archive: "default"
};
